export default __webpack_public_path__ + "static/media/SIFA_NL_INTRO.a25fece6.mp3";